var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyComp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xCE\\xD3\\xC8_9",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_9",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#050506;}.cls-2{fill:#231300;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,2.25H10A7.66,7.66,0,0,0,2.3,9.9V26A7.67,7.67,0,0,0,10,33.64H26A7.67,7.67,0,0,0,33.7,26V9.9A7.66,7.66,0,0,0,26,2.25Zm1.48,9-3.06,4.15a1.22,1.22,0,0,1-1.53.34,11.07,11.07,0,0,0-3.85-1.11,11.18,11.18,0,0,0-5.78,1,1.64,1.64,0,0,1-1.8-.23l-.23-.23L11.14,15,8.47,11.2a1.08,1.08,0,0,1,.3-1.56,18.18,18.18,0,0,1,18.49,0A1.06,1.06,0,0,1,27.52,11.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.37,11.19a1.5,1.5,0,0,0-2,.77l-1.15,2.6a7.61,7.61,0,0,1,.83,0,11.2,11.2,0,0,1,2.23.47l.83-1.88A1.5,1.5,0,0,0,21.37,11.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyComp);
export default __webpack_public_path__ + "static/media/body-comp.d025f617e4de3ce878991eb9166338c0.svg";
export { ForwardRef as ReactComponent };